module.exports = __webpack_public_path__ + "img/fi-rr-circle-small.52c44fca.svg";